import { render } from "./TransitionPlusButton.vue?vue&type=template&id=18026495&ts=true"
import script from "./TransitionPlusButton.vue?vue&type=script&lang=ts"
export * from "./TransitionPlusButton.vue?vue&type=script&lang=ts"

import "./TransitionPlusButton.vue?vue&type=style&index=0&id=18026495&lang=scss"
import "./TransitionPlusButton.vue?vue&type=style&index=1&id=18026495&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__